import React from 'react'
import PropTypes from 'prop-types'
import { Image, Transformation } from 'cloudinary-react'
import { CLOUDINARY_NAME } from '../../../constants'
import {
    getCloudinaryPublicIdFromUrl,
    getCloudinarySmbEmbossOverlay,
    isCloudinaryUrl,
} from '../../../utils/cloudinaryUtils'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    cardPreviewWrapper: () => {
        return {
            position: 'relative',
            width: '100%',
            margin: '.5rem auto 20px',
        }
    },
    embossPreview: {
        position: 'absolute',
        left: '11%',
        color: 'white',
        textShadow: 'rgb(0, 0, 0) 0px 0px 2px',
        top: '73%',
        fontSize: '60%',
        [theme.breakpoints.up(350)]: {
            fontSize: '75%',
            top: '78%',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '80%',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '105%',
        },
    },
}))
const SmbPlasticCardPreview = (props) => {
    const {
        cardNetwork,
        cardImageUrl,
        merchant,
        embossName = true,
        withYourLogoHere = false,
        cardPreviewWrapperStyles = false,
        showDynamicEmboss = false,
        cardType = null,
        isGiftProgram = false,
        ...otherProps
    } = props
    const { anticipatedNameOnCard, anticipatedMessageOnCard } = useSelector(
        (state) => state.smbCart
    )
    const classes = useStyles({ cardPreviewWrapperStyles })

    if (merchant?.image) {
        return (
            <Image
                cloudName={CLOUDINARY_NAME}
                publicId={merchant?.image}
                loading="lazy"
                {...otherProps}
            />
        )
    }

    return cardPreviewWrapperStyles ? (
        <div className={classes.cardPreviewWrapper}>
            {isCloudinaryUrl(cardImageUrl) ? (
                <>
                    <Image
                        cloudName={CLOUDINARY_NAME}
                        publicId={getCloudinaryPublicIdFromUrl(cardImageUrl)}
                        loading="lazy"
                        {...otherProps}
                    >
                        <Transformation
                            rawTransformation={getCloudinarySmbEmbossOverlay(
                                cardNetwork,
                                cardType,
                                embossName,
                                withYourLogoHere,
                                merchant,
                                isGiftProgram
                            )}
                        />
                        <Transformation quality="auto" fetchFormat="auto" />
                    </Image>
                    {showDynamicEmboss && (
                        <div className={classes.embossPreview}>
                            {anticipatedNameOnCard || 'CARD HOLDER'}
                            <br />
                            {anticipatedMessageOnCard || ''}
                        </div>
                    )}
                </>
            ) : (
                <>
                    <img
                        src={cardImageUrl}
                        alt="Gift card preview"
                        loading="lazy"
                        {...otherProps}
                    />
                    {showDynamicEmboss && (
                        <div className={classes.embossPreview}>
                            {anticipatedNameOnCard || 'CARD HOLDER'}
                            <br />
                            {anticipatedMessageOnCard || ''}
                        </div>
                    )}
                </>
            )}
        </div>
    ) : (
        <>
            {isCloudinaryUrl(cardImageUrl) ? (
                <>
                    <Image
                        cloudName={CLOUDINARY_NAME}
                        publicId={getCloudinaryPublicIdFromUrl(cardImageUrl)}
                        loading="lazy"
                        {...otherProps}
                    >
                        <Transformation
                            rawTransformation={getCloudinarySmbEmbossOverlay(
                                cardNetwork,
                                cardType,
                                embossName,
                                withYourLogoHere,
                                merchant,
                                isGiftProgram
                            )}
                        />
                        <Transformation quality="auto" fetchFormat="auto" />
                    </Image>
                    {showDynamicEmboss && (
                        <div className={classes.embossPreview}>
                            {anticipatedNameOnCard || 'CARD HOLDER'}
                            <br />
                            {anticipatedMessageOnCard || ''}
                        </div>
                    )}
                </>
            ) : (
                <>
                    {/* Shown on Builder page for Cobrands*/}
                    <img
                        src={cardImageUrl}
                        alt="Gift card preview"
                        loading="lazy"
                        {...otherProps}
                    />
                    {showDynamicEmboss && (
                        <div className={classes.embossPreview}>
                            {anticipatedNameOnCard || 'CARD HOLDER'}
                            <br />
                            {anticipatedMessageOnCard || ''}
                        </div>
                    )}
                </>
            )}
        </>
    )
}

SmbPlasticCardPreview.propTypes = {
    cardNetwork: PropTypes.string.isRequired,
    cardImageUrl: PropTypes.string.isRequired,
    merchant: PropTypes.shape({
        image: PropTypes.string,
    }),
    embossName: PropTypes.bool,
    withYourLogoHere: PropTypes.bool,
    cardPreviewWrapperStyles: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object,
    ]),
    showDynamicEmboss: PropTypes.bool,
    cardType: PropTypes.string,
    isGiftProgram: PropTypes.bool,
}
export default SmbPlasticCardPreview
